
import Server from "src/server";
import { EventBus } from "src/eventBus";

export default
  {
    namespaced: true,
    state:
    {
      isLoading: false,
      logs: []
    },

    mutations:
    {

    },

    actions:
    {
      reset(context) {
        context.state.logs = [];
      },

      async setLogs(context) {
        try {
          let workspace = context.rootState.wsStore.workspace;
          if (!workspace)
            return;

          context.state.isLoading = true;
          var result = Server.post("getLogs", { workspace }).promise.then(function (result) {
            context.state.isLoading = false;
            if (!result.data.success)
              throw (result.data.error);

            context.state.logs = result.data.logs;
            return result;
          });
        }
        catch (e) {
          console.log("Failed 'getLogs' server call. " + e.toString());
          context.state.isLoading = false;
          return { data: { success: false, error: e } };
        }
      },

      addLog(context, { log }) {
        if (!log)
          return;

        // only add if in workflows which means in workspace
        var workflows = context.rootState.wfStore.workflows;
        var workflow = workflows.find(a => a._id == log.workflow);
        if (workflow) {
          log.workflow = {
            _id: log.workflow,
            name: workflow.name
          }
          context.state.logs.unshift(log);
        }
      },

      async deleteLogs(context, {workspace, date}) {
        try {
          context.state.isLoading = true;
          var result = await Server.post("deleteLogs", { workspace, date }).promise;
          console.log(result);
          if (!result.data.success)
            throw (result.data.error);
          
          context.dispatch("setLogs");
        }
        catch(e) {
          context.state.isLoading = false;
          console.log("Failed 'deleteLogs' server call. " + e.toString());
          EventBus.$emit("showAlert", {
            title: "Error",
            message: "Failed to delete logs. Please try again.", 
            type: "error"
          });
          return { data: { success: false, error: e } };
        }
      }
    },

    getters:
    {

    }
  };



// WEBPACK FOOTER //
// ./src/store/log.js